import { PromptCategory } from '@common/model/admin/thirdPartyApi';
import { Prompt } from '../api/thirdPartyApi';
import { PromptSelection } from '../types';

const replacePromptSection = (basePrompt: string, category: PromptCategory, newContent: string): string => {
  const sectionMap: Partial<Record<PromptCategory, number>> = {
    [PromptCategory.CLOTHING]: 1,
    [PromptCategory.SMILE]: 2,
    [PromptCategory.WALL]: 3,
  };

  const targetSection = sectionMap[category];
  if (!targetSection) {
    return basePrompt;
  }

  const lines = basePrompt.split('\n');
  let found = false;

  for (let i = 0; i < lines.length; i++) {
    const sectionMatch = lines[i].match(new RegExp(`^(\\s*${targetSection}\\.\\s*)(.*)$`));
    if (sectionMatch) {
      lines[i] = `${targetSection}. ${newContent}`;
      found = true;
      break;
    }
  }

  if (!found) {
    for (let i = 0; i < lines.length; i++) {
      if (lines[i].includes('Key details:')) {
        lines.splice(i, 0, `${targetSection}. ${newContent}`);
        break;
      }
    }
  }

  return lines.join('\n');
};

export const getBasePrompt = (prompts: Prompt[]): Prompt | undefined =>
  prompts.find((p) => p.category === PromptCategory.DEFAULT) || prompts.find((p) => p.category === PromptCategory.NORMAL);

export const buildPromptFromSelection = (prompts: Prompt[], selection: PromptSelection): { prompt: string; attachmentId?: number } => {
  const basePrompt = getBasePrompt(prompts);
  if (!basePrompt) {
    return { prompt: '' };
  }

  let finalPrompt = basePrompt.content;
  let attachmentId = basePrompt.attachmentId;

  if (selection.clothing) {
    const clothingPrompt = prompts.find((p) => p.id === selection.clothing);
    if (clothingPrompt) {
      finalPrompt = replacePromptSection(finalPrompt, PromptCategory.CLOTHING, clothingPrompt.content);
      if (clothingPrompt.attachmentId) {
        attachmentId = clothingPrompt.attachmentId;
      }
    }
  }

  if (selection.wall) {
    const wallPrompt = prompts.find((p) => p.id === selection.wall);
    if (wallPrompt) {
      finalPrompt = replacePromptSection(finalPrompt, PromptCategory.WALL, wallPrompt.content);
      if (wallPrompt.attachmentId) {
        attachmentId = wallPrompt.attachmentId;
      }
    }
  }

  if (selection.smile) {
    const smilePrompt = prompts.find((p) => p.id === selection.smile);
    if (smilePrompt) {
      finalPrompt = replacePromptSection(finalPrompt, PromptCategory.SMILE, smilePrompt.content);
      if (smilePrompt.attachmentId) {
        attachmentId = smilePrompt.attachmentId;
      }
    }
  }

  return { prompt: finalPrompt, attachmentId };
};

export const promptsToSelectItems = (prompts: Prompt[], category: PromptCategory) =>
  prompts
    .filter((p) => p.category === category)
    .map((p) => ({
      value: p.id,
      label: p.name,
    }));
